import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class QuickWalkService {
  private open$ = new Subject<void>();

  readonly openQuickWalk$ = this.open$.asObservable();

  openQuickWalk(): void {
    this.open$.next();
  }
}
